import { createApp } from 'vue'
import App from './App.vue';
import router from './router/index.js'
//import Filters from '@/utils/filters'


import VueTheMask from 'vue-the-mask'

//.config.devtools = true
//import { useVuelidate } from '@vuelidate/core'
//   .use(useVuelidate)
const myApp = createApp(App)
myApp
    .use(router)    
    .use(VueTheMask)
    
myApp.mount('#app')
